// extracted by mini-css-extract-plugin
export default {"mobileNav":"mobileNavigation_mobileNav__FBCCt","opened":"mobileNavigation_opened__XbFsz"};